exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form .info-text[data-v-0662fc71]{margin-top:0}", ""]);

// exports
